// src/api/reward/rewardApi.ts
import { axiosInstance } from "src/api/axiosInstance";
import type { ApiResponse } from "src/api/common/apiTypes";
import type {
  RewardListItem,
  RewardItem,
  RewardListResponse,
  GetRewardListParams,
  RewardCreateBody,
  RewardUpdateBody,
} from "src/types/reward";

// LIST
export const getRewardListApi = async (
  params: GetRewardListParams
): Promise<ApiResponse<RewardListResponse>> => {
  const res = await axiosInstance.get<ApiResponse<RewardListResponse>>("/v1/admin/rewards", {
    params: {
      page: params.page,
      size: params.size,
      sort: [],
    },
  });
  return res.data;
};

// DETAIL
export const getRewardApi = async (id: number): Promise<ApiResponse<RewardItem>> => {
  const res = await axiosInstance.get<ApiResponse<RewardItem>>(`/v1/admin/rewards/${id}`);
  return res.data;
};

// CREATE
export const createRewardApi = async (
  payload: RewardCreateBody
): Promise<ApiResponse<RewardItem>> => {
  const res = await axiosInstance.post<ApiResponse<RewardItem>>("/v1/admin/rewards", payload);
  return res.data;
};

// UPDATE
export const updateRewardApi = async (
  id: number,
  payload: RewardUpdateBody
): Promise<ApiResponse<RewardItem>> => {
  const res = await axiosInstance.put<ApiResponse<RewardItem>>(`/v1/admin/rewards/${id}`, payload);
  return res.data;
};

// DELETE
export const deleteRewardApi = async (id: number): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.delete<ApiResponse<null>>(`/v1/admin/rewards/${id}`);
  return res.data;
};

// STATUS CHANGE
export const updateRewardStatusApi = async (
  id: number,
  isActive: boolean
): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.patch<ApiResponse<null>>(`/v1/admin/rewards/${id}`, {
    isActive,
  });
  return res.data;
};

export type { RewardListItem, RewardItem };
